<script setup>
import {useBaseStore} from "~/stores/base";

/** props **/
const props = defineProps({})

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
</script>

<template>
  <div class="module-list-overview-mobile" v-if="isMobile">
    <div class="overview-top">
      <div class="cover-image-skeleton"></div>
    </div>
    <div class="overview-bottom">
      <div class="skeleton-loader" style="width: 42.8%"></div>
      <div class="skeleton-loader" style="width: 100%"></div>
      <div class="skeleton-loader" style="width: 100%"></div>
      <div class="skeleton-loader" style="width: 38.8%;align-self: flex-end"></div>
    </div>
  </div>
  <div class="module-list-overview-desktop" v-else>
    <div class="overview-left">
      <div class="cover-image-skeleton"></div>
    </div>
    <div class="overview-right">
      <div class="skeleton-loader" style="width: 140px"></div>
      <div class="skeleton-loader" style="width: 550px"></div>
      <div class="skeleton-loader" style="width: 550px"></div>
      <div class="skeleton-loader" style="width: 100px"></div>
    </div>
  </div>
</template>

<style>
/* Define loader colors as variables */
:root {
  --loader-background-color: #EEEEEE;
  --loader-highlight-color: #DEDEDE;
}
</style>

<style scoped lang="scss">
@import "src/assets/config";

.module-list-overview-mobile {
  padding: 8px 16px;
  display: flex;
  flex-direction: column;

  background-color: #fff;
  text-align: center;

  .overview-top {
    .cover-image-skeleton {
      width: 100%;
      padding-bottom: 125%;
      background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
      background-size: 200% 100%;
      animation: loading 2s infinite ease-in-out;
    }
  }

  .overview-bottom {
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .skeleton-loader {
      width: 100%;
      height: 20px;
      background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
      background-size: 200% 100%;
      animation: loading 2s infinite ease-in-out;
    }
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}

.module-list-overview-desktop {
  width: $content-1280-width;
  margin: 16px auto 0 auto;
  display: flex;

  background-color: #fff;
  text-align: center;

  .overview-left {
    .cover-image-skeleton {
      width: 206px;
      height: 257.5px;
      background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
      background-size: 200% 100%;
      animation: loading 2s infinite ease-in-out;
    }
  }

  .overview-right {
    margin-left: 16px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .skeleton-loader {
      width: 100%;
      height: 20px;
      background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
      background-size: 200% 100%;
      animation: loading 2s infinite ease-in-out;
    }
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}
</style>
